import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import {
  CreatWidgetFormValues,
  WidgetTypes,
  WidgetValueType,
  filterValueListsForDashboard,
  valueLists,
} from '../dashboard-widget-model';
import { ValueGroup } from '../SelectCreateWidgetBy';

interface Props {
  onSelect: (value: WidgetValueType) => void;
  selectedValue: WidgetValueType;
}

export function SelectValue({ onSelect, selectedValue }: Props) {
  const { values } = useFormikContext<CreatWidgetFormValues>();
  const groups = filterValueListsForDashboard(valueLists, values.isOrgDashboard).filter(
    (group) => group.value !== 'links' || values.byType === WidgetTypes.TABLE
  );

  return (
    <Grid container direction='column' style={{ width: '100%', padding: '0 16px' }}>
      <Box>
        {groups.map((group) => (
          <ValueGroup group={group} onSelect={onSelect} selectedValue={selectedValue} />
        ))}
      </Box>
    </Grid>
  );
}
